<template>

    <div class="homecontainer container-fluid no-gutters w-container">

        <!-- 简介1 -->
        <div v-if="position == 1">
            <!-- 头部 -->
            <div class="row row-grid align-items-center">
                <div class="text-center">
                    <!-- Image -->
                    <figure class="w-100">
                        <img alt="Image placeholder" src="../../assets/img/master/master-top.jpg" class="img-fluid">
                    </figure>
                </div>
            </div>

            <div class="row row-grid align-items-center justify-content-center">

                <div class="content-container">

                    <p class="content-title">王蓉（本心）</p>


                    <div class="detail-one">
                        <img src="../..//assets/img/master/wr-one.jpg" alt="" class="detail-wr-img">
                        <div>
                            <p class="detail-wr-text">
                                本心(原名王荣),是“雍荣·草木本心”艺术玉雕/雕塑品牌的创始人,同时也是“汉泽西”玉雕艺术珍饰的发起者与践行者。她在中国玉雕艺术界拥有举足轻重的地位,是中国宋庄·大洲玉文化创意园专家委员会的重要成员。
                            </p>
                            <p class="detail-wr-text">
                                在职业生涯的早期,本心曾在文化行业担任资深职业经理人,积累了丰富的行业经验和资源。她曾担任TREE国际艺术中心总裁,期间策划并成功实施了“会走的树”大型艺术家行走写生巡展活动,这一活动不仅展示了众多
                            </p>

                        </div>
                    </div>

                    <div class="detail-two">
                        <div>
                            <p class="detail-wr-text">
                                艺术家的才华,也促进了艺术与自然的深度融合,赢得了广泛赞誉<br><br>2014年底,本心凭借对玉雕艺术的深厚情感和独到见解,创立了“雍荣·草木本心”艺术工作室,并亲自担任首席创意雕刻师。她的作品风格独特,融合了传统与现代、东方与西方的艺术元素,呈现出一种独特的艺术魅力。其中,呐喊】、【守玉人】、【简素.布衣】、【卷雪蒸云】、【风生水起】、【王夏·玉尚】、览系列】、【相框系列】等作品在行业内广受好评,荣获了多顶殊荣。<br><br>

                            </p>
                        </div>
                        <img src="../../assets/img/master/wr-two.jpg" alt="" class="detail-two-img">
                    </div>


                    <div class="detail-three">
                        <p class="detail-three-text">
                            2017年,本心策划并推出了具有深刻人文意义的中国艺术珍饰“汉泽西”玉雕艺术品牌发布活动。这一品牌的推出,不仅展示了她在玉雕艺术上的深厚造诣,也体现了她对传统文化的热爱与传承。此后,她每年都推出新的艺术融合作品,不断为观众带来惊喜。<br><br>
                            她的代表系列作品包括:【竹海系列】(2017年),以竹子为题材,展现了竹子的坚韧与高雅;【翼系列】(2018年),以翅膀为灵感,寓意着自由与梦想;[路系列】(2019年),以道路为主题,表达了人生的探索与追求;玉遇·一席系列】(2019年),则是以玉为媒介,展现了人与人之问的情感交流与共鸣;云上系列】2020年),以云朵为元素,寓意着高远与梦想;迷系列】(2020年),则是以迷宫为灵感,探讨了人生的迷茫与探索<br><br>
                            除了艺术创作,本心还出版了【会走的夫妻树】心灵游记和【玉遇,汉泽西】个人艺术集。这两部作品不仅记录了她的艺术创作历程,也展现了她对生活的热爱与感悟。她的作品和理念,无疑为中国的玉雕艺术界注入了新的活力和思若
                        </p>
                    </div>


                </div>




            </div>


        </div>
        <!-- 简介2 -->
        <div v-if='position == 2'>

            <div class="row row-grid align-items-center">
                <div class="text-center">
                    <!-- Image -->
                    <figure class="w-100">
                        <img alt="Image placeholder" src="../../assets/img/master/master-qb.jpg" class="img-fluid">
                    </figure>
                </div>
            </div>

            <div class="row row-grid align-items-center justify-content-center">
                <div class="content-container">

                    <p class="content-title">曲<span class="space"> </span>波</p>


                    <div class="detail-one">
                        <img src="../..//assets/img/master/qb-one.jpg" alt="" class="detail-one-img">
                        <div>
                            <p class="detail-one-text">
                                曲波男,1968年生人,首届“中国玉雕大工匠”、国家级高级/一级技师、北京市工艺美术大师、河南省工艺美术大师、河南省玉石雕刻大师、河北省工美行业艺术大师、中国玉文化研究会玉雕专业委员会常务副秘书长、中国工艺美术协会玻璃艺术委员会委员、河南省珠宝玉石首饰行业协会常务理事、沈丘玉文化商业联合会副会长。多年来创作出众多优秀玉雕翡翠作品,深受业内人士及藏
                            </p>

                        </div>

                    </div>


                    <div class="detail-two">
                        <div>
                            <p class="detail-two-text">
                                毕业院校消华大学美术学院《中国工艺美术大师研修班》进修结业荣誉称号首中国玉雕大工匠、中国玉石艺术大师、北京工艺美术大师。河南省工艺美术大师、河北省工美行业艺术大师、国家级高级/一级技师、河南省玉石雕刻大师、中国玉雕艺术家、中华玉雕艺术大师、中华玉雕工艺师人物关系1988年从事学习玉石雕刻,1991年师从北京玉器厂活雕刻名家吴振岚,康维汉,学习素活制作;1994年到广东从事小件产品的制作;2001年在龙鼎皇艺中心担任玉石艺术设计。在此期间,得到了中国工艺美术大师宋世义的指点;2004年加入中国自玉研究会,同年拜宋建国大师为师,学习大师制作理念;2005年创办《善玉坊玉雕工作密》,2017年更名为《善钰玉雕工作密》。
                                <br><br>社会职务<br>中国文化研究会玉专业委员会常务秘书长<br>河南省殊宝玉石首饰行业协会常务理事<br>沈丘玉文化商业联合会副会长
                            </p>
                        </div>
                        <img src="../../assets/img/master/qb-two.jpg" alt="" class="detail-two-img">
                    </div>

                    <div class="detail-three">

                        <p class="detail-three-text">从艺经历</p>
                        <p class="detail-three-text">
                            1988年从事学习玉石雕刻,1991年师从北京玉器厂素活雕刻名家吴振凤,康维汉,学习素活制作;1994年到广东从事小件产品的制作;2001年在龙鼎皇艺中心担任玉石艺术设计。在此期问,得到了中国工艺美术大师宋世义的指点;2004年加入中国自玉研究会,同年拜宋建国大师为师,学习大师制作理念;2005年创办《善玉坊玉雕工作室》,2017年更名为《善钰玉雕工作室》。
                        </p>
                        <p class="detail-three-text">技艺简介</p>
                        <p class="detail-three-text">
                            玉雕制作中的,阅雕,浮雕,镂空雕刻,瓶素中的掏膛,活环。活链,以及山子雕,人物,动物,花卉等工艺。制作玉器素活薄胎工艺,曾拜北京玉器厂素活师傅康维汉、吴振风为师。制作素活器皿水上漂,也曾自己制作一些工具及机器改造。
                        </p>
                        <p class="detail-three-text">主要成果</p>
                        <p class="detail-three-text">《涅槃》被国家地质博物馆收藏</p>
                        <p class="detail-three-text">《灵芝》被香港东方艺术馆馆收藏</p>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《观音牌子》</p>
                            <p class="detail-three-text">2013年“中华龙奖”</p>
                            <p class="detail-three-text">银奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《海天佛国》</p>
                            <p class="detail-three-text">2014年“中华龙奖”</p>
                            <p class="detail-three-text">金奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《鱼跃龙门》</p>
                            <p class="detail-three-text">2014年“中华龙奖”</p>
                            <p class="detail-three-text">最佳工艺奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《和田黄玉观音》</p>
                            <p class="detail-three-text">2015年“中国玉石雕刻艺术百花奖</p>
                            <p class="detail-three-text">银奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《财神童子》</p>
                            <p class="detail-three-text">2015年“中原玉博杯”</p>
                            <p class="detail-three-text">金奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《水仙花》</p>
                            <p class="detail-three-text">2015年“中原玉博杯”</p>
                            <p class="detail-three-text">金奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《松子葡萄》</p>
                            <p class="detail-three-text">2015年“中原玉博杯”</p>
                            <p class="detail-three-text">银奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《带子上朝》</p>
                            <p class="detail-three-text">2015年“中原玉博杯”</p>
                            <p class="detail-three-text">银奖</p>

                        </div>


                        <div class="detail-jx-container">
                            <p class="detail-three-text">《守望》</p>
                            <p class="detail-three-text">2015年“中华龙奖”</p>
                            <p class="detail-three-text">最佳创意奖</p>

                        </div>


                        <div class="detail-jx-container">
                            <p class="detail-three-text">《嵌百宝鸟型对瓶》</p>
                            <p class="detail-three-text">2015年“中国玉石雕刻天工奖</p>
                            <p class="detail-three-text">优秀奖</p>

                        </div>


                        <div class="detail-jx-container">
                            <p class="detail-three-text">《六臂观音》</p>
                            <p class="detail-three-text">2016年“陆子冈杯”</p>
                            <p class="detail-three-text">金奖</p>

                        </div>


                        <div class="detail-jx-container">
                            <p class="detail-three-text">《年年有余》</p>
                            <p class="detail-three-text">2016年“陆子冈杯”</p>
                            <p class="detail-three-text">银奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《蜜蜡弥勒佛》</p>
                            <p class="detail-three-text">2016年“中国玉石雕刻百花奖”</p>
                            <p class="detail-three-text">优秀奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《十八罗汉》</p>
                            <p class="detail-three-text">2017年“河北省玉雕技艺大赛</p>
                            <p class="detail-three-text">优秀奖</p>

                        </div>


                        <div class="detail-jx-container">
                            <p class="detail-three-text">《十八罗汉串》</p>
                            <p class="detail-three-text">2017年“原创亲工匠心传承”</p>
                            <p class="detail-three-text">金杯</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《莲花观音》</p>
                            <p class="detail-three-text">2016年“中原玉博杯”</p>
                            <p class="detail-three-text">金奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《力争上游》</p>
                            <p class="detail-three-text">2017年“原创亲工匠心传承</p>
                            <p class="detail-three-text">银杯</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《十一面观世音》</p>
                            <p class="detail-three-text">2018年“百花杯”中国工艺美术精品奖</p>
                            <p class="detail-three-text">银奖</p>

                        </div>

                        <div class="detail-jx-container">
                            <p class="detail-three-text">《上善若水》</p>
                            <p class="detail-three-text">2020年北京工美杯</p>
                            <p class="detail-three-text">银奖</p>

                        </div>

                        <p class="detail-three-text">从艺感悟</p>
                        <p class="detail-three-text">
                            曲波大师在艺术创作过程中,结合“天人合一”的艺术创作风格,汲取民族文化思想,结合新形势下的创作需求,在制作每一件产品时,都会想根据其原料特性特点,去设计制作,追求物尽其用,精工细作。
                        </p>

                    </div>

                </div>
            </div>
        </div>
        <!-- 简介3 -->
        <div v-if="position == 3">

            <div class="row row-grid align-items-center">
                <div class="text-center">
                    <!-- Image -->
                    <figure class="w-100">
                        <img alt="Image placeholder" src="../../assets/img/master/master-dj.jpg" class="img-fluid">
                    </figure>
                </div>
            </div>
            <div class="row row-grid align-items-center justify-content-center">
                <div class="content-container">

                    <p class="content-title">杜 建 毅</p>

                    <div class="detail-one">
                        <img src="../..//assets/img/master/djy-one.jpg" alt="" class="detail-dj-img">
                        <div class="detail-djy-text-container">
                            <p class="detail-djy-text">·北京花经金工坊文化发展有限公司; </p>
                            <p class="detail-djy-text">·1971年开始进入北京工艺美术品总公司花丝镶嵌厂; </p>
                            <p class="detail-djy-text">·1993年开创个人工作室--花丝金工坊,专研中式珠宝的创作; </p>
                            <p class="detail-djy-text">·2015年9月,被聘为北京市故宫文化产品开发有限公司非物质文化遗产研发专业顾问; </p>
                            <p class="detail-djy-text">
                                ·2018年10月受台湾珠宝金工协会邀请赴台开办花丝金工技艺训练营活动,并在台南高雄科技大学、台中朝阳科技大学、台北艺术大学进行了三场学术演讲; </p>

                        </div>

                    </div>


                    <div class="detail-two">
                        <div>
                            <p class="detail-djy-text-two">·2020年9月20号在第四届工匠中国论坛年会上被授予中国工匠精神传承人物奖。</p>
                            <p class="detail-djy-text-two">简历</p>
                            <p class="detail-djy-text-two">杜建毅-男(汉族)1955年10月北京出生,北京市人,花丝镶一级/技师(高级金属摆件工)。</p>
                            <p class="detail-djy-text-two">1971年北京市25中学毕业被分配至北京花丝镶嵌厂学徒。</p>
                            <p class="detail-djy-text-two">1980年任花丝厂二车间主任,1984年任花丝二厂业务科长，1988年任花丝二分厂副厂长(主管生产经营)</p>
                            <p class="detail-djy-text-two">1994初停薪留职,走向社会,开始新中式珠宝首饰的研制工作。</p>
                            <p class="detail-djy-text-two">1997年在北京珠宝第一厅开办个人工作室(花丝金工坊)以前店后厂形式开展花丝镶嵌珠宝首饰的高级私人订制业务。</p>
                            <p class="detail-djy-text-two">
                                2015年9月宣布退体,被故宫博物院文化产品开发有限公司聘为非物质文化遗产研发专业顾问,其23件代表作长期被宝蕴楼收藏,代表故宫博物院皇家珠宝文创精品向世界各国贵宾展示。
                            </p>
                            <p class="detail-djy-text-two">2017年被故宫学校聘为顾问,开办皇家珠宝技艺研习班,开展皇家珠宝技艺传承、宣传及推广工作。</p>



                        </div>
                        <img src="../../assets/img/master/djy-two.jpg" alt="" class="detail-djy-img">
                    </div>

                    <div class="detail-three">
                        <p class="detail-djy-text-two">
                            2018年初受邀作为颁奖嘉宾参加国家珠宝玉石质景检验中心(NGTC)全国珠宝金工技艺大赛颁奖大会,首次在会场上向全国业内代表展示新型中式珠宝首饰精品,宣传非遗文化,并被收录在(NJTC)2017-2018年中国珠宝文化蓝皮书。
                        </p>
                        <p class="detail-djy-text-two">
                            2018年3月注册北京花丝金工坊文化发展有限公司,4月迁入北京宋庄大洲玉文化创意园,建立一个集精品展示,宜传推广,技术培训为一体的工作室,并受文旅部干部管理学院邀请,先后为广东、福建、京津等省市基层文旅干部代表讲授非遗文化“花丝镶嵌金工技艺”传承与发展的专业课程。同时面向社会开展艺术整赏及工艺体验等活动。
                        </p>
                        <p class="detail-djy-text-two">
                            2018年10月受台湾珠宝金工协会邀请赴台开办一期(三天)花丝金工技艺训练营活动,并在台南高雄科技大学、台中朝阳科技大学、台北艺术大学进行了三场学术演讲,宜传中国传统文化,演示花丝金工技艺,展示当代中国珠宝文化的魅力，反响热烈。
                        </p>
                        <p class="detail-djy-text-two">2019年11月受邀在中央美院做“花丝镶嵌工艺的古往今来”的主片讲座,受到好评。</p>
                        <p class="detail-djy-text-two">2020年9月20号在第四届工匠中国论坛年会上被授予2019年中国工匠精神传承人物奖。</p>
                        <p class="detail-djy-text-two">2021年第五届工匠中国论坛对话嘉宾。</p>
                    </div>

                </div>
            </div>

        </div>
        <!-- 简介4 -->
        <div v-if="position == 4">

            <div class="row row-grid align-items-center">
                <div class="text-center">
                    <!-- Image -->
                    <figure class="w-100">
                        <img alt="Image placeholder" src="../../assets/img/master/xyc-title.jpg" class="img-fluid">
                    </figure>
                </div>
            </div>


            <div class="row row-grid align-items-center justify-content-center">
                <div class="content-container">

                    <p class="content-title">辛 玉 晨</p>


                    <div class="detail-one">
                        <img src="../..//assets/img/master/xyc-one.jpg" alt="" class="detail-wr-img">
                        <div>
                            <p class="detail-wr-text">
                                辛玉晨,是中国当代备受瞩目的玉雕大师,以其非凡的艺术才华和对玉雕艺术的深刻理解,在业界树立了独特的标杆。辛玉晨的作品在国际国内玉雕艺术领域均享有极高的评价和影响力。
                            </p>
                            <p class="detail-wr-text">
                                对玉石抱有浓厚兴趣与敬畏之心的辛玉晨,通过多年的刻苦钻研与实践,逐渐在玉雕艺术领域崭露头角。他擅长从自然万物与人文历史中汲取灵感,将传统玉雕技艺与现代设计理念相融合,创造出既蕴含深厚文化底蕴又不
                            </p>

                        </div>
                    </div>

                    
                    <div class="detail-two">
                        <div>
                            <p class="detail-wr-text">
                                失时尚气息的作品。辛玉晨的作品,不仅形态优美,更蕴含深刻的情感与哲思,每一件都是对玉石自然之美与人文情感完美结合的诠释。<br><br>
                                在创作过程中,辛玉晨追求极致的细节与独特的创意。他充分利用玉石的天然色泽与纹理,通过巧妙的构思与精湛的雕刻技艺,赋予每一块玉石以新的生命与故事。无论是山水、花鸟的自然景观,还是历史人物、神话传说的再现,辛玉晨的作品总能触动人心,引发观者共鸣。<br><br>
                                辛玉晨不仅亲自参与创作,还致力于培养年轻玉雕人才,推动玉雕艺术的传承与发展。他经常与同行交流心得,分享创作经验,鼓励年轻一代大胆创新,为中国玉雕艺术事业注入新的活力与希望。<br><br>
                                除了在艺术创作上的卓越贡献,辛玉晨还积极投身社会公益事业。她多次参与慈善拍卖,将自己精心雕琢的作品捐赠给需要帮助的人群,用实际行动践行艺术家的社
会责任与担当。
                            </p>
                        </div>
                        <img src="../../assets/img/master/xyc-two.jpg" alt="" class="detail-two-img">
                    </div>

                    <div class="detail-three">
                        <p class="detail-three-text">
                            辛玉晨的艺术成就得到了业界的广泛认可与赞誉。他曾荣获多项国内外玉雕艺术大赛的奖项,作品被多家知名艺术机构和私人收藏家所珍藏。同时,她还多次受邀参加国内外的艺术展览与交流活动,成为中国玉雕艺术在国际舞台
                            上的一张亮丽名片。<br><br>
                            辛玉晨以其非凡的艺术才华、精湛的技艺和深厚的文化内涵,成为了中国当代玉雕艺术的杰出代表。她的作品不仅展示了中国玉雕艺术的独特魅力,更为中国传统文化的传承与发展做出了重要贡献。
                        </p>
                    </div>

                </div>


               


            </div>

        </div>

    </div>

</template>

<script>
export default {
    name: 'MasterDetail',
    data() {
        return {
            url: '',
            position: this.$route.params.position
        }
    },
    created() {

    },
    mounted() {
        this.position = this.$route.params.position
    }

}
</script>

<style>
.w-container {
    background-color: white;
}

.img-fluid {
    max-width: 100%;
    height: auto;
}

.w-100 {
    width: 100% !important;
}

.content-container {
    background-color: #ffffff;
    margin-top: 50px;
    max-width: 1400px;
}

.content-title {
    width: 100%;
    height: auto;
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 2rem;
}

.space {
    margin-left: 10px;
    margin-right: 10px;
}


.detail-one {
    margin-left: 10%;
    display: flex;

}

.detail-one-img {
    width: 40%;
    height: 100%;
    margin-right: 50px;
    margin-top: 20px;

}

.detail-one-text {
    font-weight: bold;
    text-indent: 2em;
    margin-right: 10%;
    margin-top: 20px;
    font-size: 1.1rem;
    letter-spacing: 3px;
}

.detail-two {
    margin-left: 10%;
    display: flex;
    margin-top: 50px;
    margin-right: 10%;
}

.detail-two-text {
    font-weight: bold;
    text-indent: 2em;
    font-size: 1.1rem;
    letter-spacing: 3px;

}

.detail-two-img {
    width: 40%;
    height: 100%;
    margin-left: 40px;

}

.detail-three {
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 50px;
    margin-bottom: 50px;
}

.detail-three-text {
    font-weight: bold;
    font-size: 1.1rem;
    letter-spacing: 3px;
    flex: 1;
}

.text-space {
    margin-left: 200px;

}

.detail-jx-container {
    display: flex;
}

.detail-djy-text {
    font-weight: bold;
    font-size: 1.1rem;
    ;
    letter-spacing: 3px;
    margin-right: 10%;

}

.detail-dj-img {
    width: 40%;
    height: 100%;
    margin-right: 40px;
    margin-top: 20px;
}

.detail-djy-text-container {
    margin-top: 20px;
}

.detail-djy-text-two {
    font-weight: bold;
    font-size: 1.1rem;
    letter-spacing: 3px;

}

.detail-djy-img {
    width: 40%;
    height: 100%;
    margin-left: 40px;
}


.detail-wr-img {
    width: 40%;
    height: 100%;
    margin-right: 40px;
    margin-top: 20px;
}

.detail-wr-text {
    font-weight: bold;
    font-size: 1.1rem;
    ;
    letter-spacing: 3px;
    margin-right: 10%;

}
</style>